import RaySync from 'project-config/services/raysync/raysync'
import Protocol from 'project-config/services/raysync/protocol'
import { useRaysyncStore } from '@/store/raysync/raysync-store'
import { useOutputStore } from '@/store/output/output-store'
import { getShareKey } from '@/utils'

const setRaysyncClientVersion = useRaysyncStore.getState().setRaysyncClientVersion
const getPlatform = useOutputStore.getState().getPlatform

export default new RaySync(new Protocol(), {
  setRaysyncClientVersion,
  isPicturePlatform: () => false,
  getPlatform,
  shareKey: getShareKey(),
})
